import { commonStyles, buttonStyle } from "src/Library/CommonStyles";

export const ContainerTriangulationOnboardingStyles = (theme) => ({
  parentDiv: {
    backgroundColor: theme.colors.bgWhite,
    paddingTop: theme.spacing.ms,
  },
  typeHeading: {
    color: theme.colors.text,
    fontSize: '36px',
    fontWeight: 'bold',
  },
  typeSubheading: {
    fontSize: '21px',
    color: theme.colors.textSecondary,
    marginTop: theme.spacing.ms,
  },
  containerPermissionSelection: {
    width: '230px',
    marginTop: theme.spacing.ms,
    '& .ant-select-selection': {
      border: `1px solid ${theme.colors.textTertiary}`,
      borderRadius: `${theme.radius.md}px`,
      '& .ant-select-arrow .ant-select-arrow-icon': {
        color: theme.colors.text,
      }
    },
  },
  checkbox: {
    marginRight: theme.spacing.sm,
    '& .ant-checkbox-checked .ant-checkbox-inner': {
      backgroundColor: theme.colors.primaryDark,
      borderColor: theme.colors.primaryDark,
    },
  },
  flexRow: {
    ...commonStyles(theme).flexRow,
  },
  justifySpaceBetween: {
    ...commonStyles(theme).justifySpaceBetween,
  },
  nextButton: {
    ...buttonStyle(theme.colors.bgWhite, theme.colors.primaryDark, `1px solid ${theme.colors.primaryDark}`),
    borderRadius: `${theme.radius.md}px`,
    padding: `0 ${theme.spacing.md}px`,
    marginRight: theme.spacing.md,
  },
  nextButtonDisabled: {
    ...buttonStyle(theme.colors.bgWhite, theme.colors.border, `1px solid ${theme.colors.border}`),
    borderRadius: `${theme.radius.md}px`,
    padding: `0 ${theme.spacing.md}px`,
    pointerEvents: 'none',
  },
  exportOnlyButton: {
    ...buttonStyle(theme.colors.textSecondary, theme.colors.bgWhite, `1px solid ${theme.colors.textTertiary}`),
    borderRadius: `${theme.radius.md}px`,
    padding: `0 ${theme.spacing.md}px`,
  },
  addStuffingAddress: {
    marginTop: '6%',
    color: theme.colors.primaryDark,
    fontSize: '21px',
    fontWeight: theme.fontWeight.semibold,
    cursor: 'pointer',
  },
  addressLabel: {
    color: theme.colors.textSecondary,
    fontSize: theme.fontSize.small,
    marginTop: theme.spacing.sm,
  },
  addressTitle: {
    color: theme.colors.textSecondary,
    fontSize: theme.fontSize.h3,
    fontWeight: theme.fontWeight.semibold,
    marginBottom: theme.spacing.ms,
  },
  googleMapDiv: {
    '& .gm-fullscreen-control': {
      display: 'none',
    },
    height: '200px',
    width: '100%',
  },
  selectedAddress: {
    border: `1px solid ${theme.colors.primaryDark}`,
    borderRadius: `${theme.radius.md}px`,
    marginTop: '5px',
    padding: '11px 25px 13px 13px',
  },
  organisationListTitle: {
    fontSize: theme.fontSize.caption,
    color: theme.colors.textTertiary,
  },
  inputField: {
    border: `1px solid ${theme.colors.textTertiary}`,
  },
  selectField: {
    '& .ant-select-selection': {
      border: `1px solid ${theme.colors.textTertiary}`,
      borderRadius: `${theme.radius.md}px`,
      '& .ant-select-arrow .ant-select-arrow-icon': {
        color: theme.colors.text,
      }
    },
  },
  inchargeRadio: {
    ...commonStyles(theme).flexRowDiv,
    '& .ant-radio': {
      marginTop: '10px',
    },
    '& span.ant-radio + *': {
      width: '100%',
    },
    '& .ant-radio-checked::after': {
      border: 'none',
    },
  },
  selectedStuffingAddress: {
    borderRadius: `${theme.radius.md}px`,
    padding: '11px 25px 13px 13px',
    backgroundColor: theme.colors.bgSubtle,
    border: `1px solid ${theme.colors.bgSubtle}`,
    width: '260px',
    marginBottom: '35px',
  },
  addMore: {
    cursor: 'pointer',
    color: '#3478B7',
    fontSize: theme.fontSize.small,
    margin: `${theme.spacing.sm}px 0 0 4%`,
    width: '12%',
  },
  sideDrawer: {
    '& .ant-drawer-body': {
      padding: 0,
    },
    '& .ant-drawer-content-wrapper': {
      minWidth: '800px',
      color: theme.colors.textSecondary,
    },
    '& .ant-drawer-title': {
      fontWeight: theme.fontWeight.semibold,
      fontSize: theme.fontSize.h1,
    },
  },
  changeButton: {
    cursor: 'pointer',
    color: '#2373BD',
    fontSize: theme.fontSize.caption,
    marginLeft: theme.spacing.sm,
    fontWeight: theme.fontWeight.semibold,
  },
  orgList: {
    fontSize: theme.fontSize.small,
    color: theme.colors.textSecondary,
    fontWeight: theme.fontWeight.semibold,
    marginTop: `${theme.spacing.xs}px`
  },
  emailPermission: {
    marginTop: '38px',
    '& .ant-switch-checked': {
      backgroundColor: '#3478B7',
    },
  },
  addressList: {
    backgroundColor: theme.colors.bgSubtle,
    borderRadius: `${theme.radius.md}px`,
    padding: `${theme.spacing.sm}px ${theme.spacing.md}px ${theme.spacing.md}px ${theme.spacing.md}px`,
    marginBottom: theme.spacing.ms,
  },
  addressHeading: {
    color: theme.colors.text,
    fontWeight: theme.fontWeight.semibold,
  },
  addressOtherDetails: {
    color: theme.colors.text,
    fontSize: theme.fontSize.small,
    marginTop: '6px',
  },
  footer: {
    borderTop: '1px solid #EDEDED',
    padding: '14px 11% 14px 24px',
    display: 'flex',
    position: 'absolute',
    width: '100%',
    // justifyContent: 'flex-start',
    bottom: 0,
    alignItems: 'center',
  },
  cancelButton: {
    color: theme.colors.textSecondary,
    cursor: 'pointer',
  },
  radio: {
    '& .ant-radio-checked .ant-radio-inner': {
      borderColor: theme.colors.primaryDark,
    },
    '& .ant-radio-inner::after': {
      backgroundColor: theme.colors.primaryDark,
    },
    '& .ant-radio-checked::after': {
      border: 'none',
    },
  },
  inputSearch: {
    '& .ant-input': {
      border: `1px solid ${theme.colors.textTertiary}`,
    },
  },
});
